import { Card, CardContent } from "@/components/ui/card";
import { FormControl, FormItem, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import InputFieldContainer from "./InputFieldContainer";
import StandalonePriceListSelect from "./StandalonePriceListSelect";
import { useState } from "react";

interface ExtraPriceInputProps {
  control: any;
  name: string;
}

export default function ExtraPriceInput({
  control,
  name,
}: ExtraPriceInputProps) {
  const [selectedPriceListId, setSelectedPriceListId] = useState<number | null>(
    null
  );

  return (
    <InputFieldContainer
      label="Extra Price"
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className="col-span-2">
          <div className="flex gap-4">
            <div className="w-48">
              <StandalonePriceListSelect
                unSelect={false}
                value={selectedPriceListId}
                onPriceListChange={setSelectedPriceListId}
              />
            </div>

            {(() => {
              console.log(
                "selectedPriceListId",
                selectedPriceListId,
                field.value
              );

              if (!selectedPriceListId) {
                return null;
              }

              const currentPrice = field.value?.find(
                (p: any) => p.price_listId === selectedPriceListId
              ) || { price: 0, price_listId: selectedPriceListId };

              const handlePriceChange = (newPrice: number) => {
                const newPrices = [...(field.value || [])];
                const priceIndex = newPrices.findIndex(
                  (p: any) => p.price_listId === selectedPriceListId
                );

                if (priceIndex >= 0) {
                  newPrices[priceIndex] = {
                    ...newPrices[priceIndex],
                    price: newPrice,
                  };
                } else {
                  newPrices.push({
                    price: newPrice,
                    price_listId: selectedPriceListId,
                  });
                }

                field.onChange(newPrices);
              };

              return (
                <Input
                  type="number"
                  placeholder="Enter extra price"
                  value={currentPrice.price}
                  onChange={(e) =>
                    handlePriceChange(parseFloat(e.target.value))
                  }
                  className="w-full"
                  disabled
                />
              );
            })()}
          </div>

          <FormMessage />
        </FormItem>
      )}
    />
  );
}
